import {createAsyncThunk} from "@reduxjs/toolkit";
import {liquidProduct} from "Utils/liquidUtils";

export const liquidGetProduct = createAsyncThunk(
  'product/liquidGetProduct',
  async ({groupingId}, {getState}) => {

    const {auth, elements} = getState()

    const {status, products} = await liquidProduct(elements.liquid, {
      ids: [groupingId],
      latitude: elements.address.latitude,
      longitude: elements.address.longitude,
      shipState: elements.address.state,
      top100: !auth.productionReady
    })

    return {status, products}
  }
)
export const liquidRefreshProduct = createAsyncThunk(
  'product/liquidRefreshProduct',
  async ({address}, {getState}) => {
    const {elements, auth, product} = getState()
    const groupingId = product?.info?.id

    const {status, products} = await liquidProduct(elements.liquid, {
      ids: [groupingId],
      latitude: address.latitude,
      longitude: address.longitude,
      shipState: address.state,
      top100: !auth.productionReady
    })
    return {status, products}
  }
)